import { Collection, Database } from '@nozbe/watermelondb';

import { HorseContactModel } from '../../../../types/HorseContact';
import { HorseModel, HorsePayload } from '../../../../types/Horses';
import { LocationModel } from '../../../../types/Location';
import { DBWriterLoggerFunction } from '../../../../types/logger';

export const prepareCreateHorse = ({
    payload,
    userId,
    organisationID,
    locationElement,
    collection,
}: {
    payload: HorsePayload;
    userId: string;
    organisationID: string;
    locationElement?: LocationModel;
    collection: Collection<HorseModel>;
}) =>
    collection.prepareCreate((horse) => {
        horse.name = payload.name;
        horse.foalDate = payload.foalDate;
        horse.gender = payload.gender;
        horse.shoeSize = payload.shoeSize;
        horse.shoeType = payload.shoeType;
        horse.shoeingCycle = payload.shoeingCycle;
        horse.shoeingCycleNotify = payload.shoeingCycleNotify;
        horse.shoeingCycleBadge = false;
        horse.hidden = !!payload.hidden;
        horse.breed = payload.breed;
        horse.workType = payload.workType;
        horse.comments = payload.comments || '';
        horse.stableName = payload.stableName;
        horse.stableAddress = payload.stableAddress;
        horse.stablePhone = payload.stablePhone;
        horse.stablePhonePrefix = payload.stablePhonePrefix;
        horse.microchipNo = payload.microchipNo;
        horse.sireName = payload.sireName;
        horse.damName = payload.damName;
        horse.locationId = locationElement?.id ? locationElement.id : null;
        horse.userId = userId;
        horse.organisationId = organisationID;
    });

export const prepareCreateHorseContacts = ({
    contacts,
    horse,
    database,
}: {
    contacts?: HorsePayload['contacts'];
    horse: HorseModel;
    database: Database;
}): HorseContactModel[] => {
    if (!contacts?.length) return [];

    const horseContactsCollection =
        database.collections.get<HorseContactModel>('horse_contacts');

    return contacts.map((contact) =>
        horseContactsCollection.prepareCreate((horseContact) => {
            horseContact.horseId = horse.id;
            horseContact.userId = horse.userId;
            horseContact.organisationId = horse.organisationId;
            horseContact.contactId = contact.id;
        }),
    );
};

export const logAddHorseActions = ({
    horse,
    horseContactsToAdd,
    logDBAction,
    tableName,
}: {
    horse: HorseModel;
    horseContactsToAdd: HorseContactModel[];
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Create horse',
        modelName: tableName,
        payload: horse,
    });

    horseContactsToAdd.forEach((createdHorseContact) =>
        logDBAction({
            message: 'Create horse - create contact',
            modelName: tableName,
            payload: createdHorseContact,
        }),
    );
};
